module.exports = __webpack_public_path__ + "img/background.70d9487a.png";